import { Close, View, WarningAltFilled } from '@carbon/icons-react';
import * as React from 'react';
import {
  Body,
  Button,
  Heading,
  Icon,
  IconComponentType,
  Tooltip,
} from 'vet-bones/design-system/components';

import { getProjectResourceCardViewPreviewButtonTestId } from 'src/constants/testIds';
import * as copy from 'src/templates/copy';
import { FileCreationMetadata } from 'src/types/fileUpload';

import styles from 'src/containers/ProjectNewResourceDialogV2/components/projectResourceCard.module.scss';

export type ProjectResourceCardProps = {
  resourceName: string;
  resourceIcon: IconComponentType;
  fileId: string;
  index: number;
  metadata?: FileCreationMetadata;
  validationError?: string;
  onViewPreview: (index: number) => void;
  onRemove: (index: number) => void;
};

export const ProjectResourceCard: React.VFC<ProjectResourceCardProps> = ({
  resourceName,
  resourceIcon,
  fileId,
  index,
  metadata,
  validationError,
  onViewPreview,
  onRemove,
}) => {
  const description = metadata
    ? copy.components.projectResourceDialog.resourceTypePanelV2.projectResourceCard.description(
        metadata.fields.length,
        metadata.rowCount,
        metadata.fields.map((f) => f.label).join(', ')
      )
    : null;

  return (
    <div className={styles.projectResourceCard}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <Icon IconComponent={resourceIcon} size="md" />
        </div>
        <div className={styles.content}>
          <Heading size="sm">{resourceName}</Heading>
        </div>
        <div className={styles.actions}>
          {validationError && (
            <Tooltip description={validationError}>
              <div
                className={styles.errorIcon}
                data-testid="project-resource-card-error-icon"
              >
                <Icon IconComponent={WarningAltFilled} size="md" />
              </div>
            </Tooltip>
          )}
          <Button
            icon={View}
            onClick={() => onViewPreview(index)}
            size="xs"
            testId={getProjectResourceCardViewPreviewButtonTestId(
              fileId,
              index
            )}
            title={
              copy.components.projectResourceDialog.resourceTypePanelV2
                .projectResourceCard.viewPreview
            }
            variant="secondary-transparent-gray"
          />
          <Button
            icon={Close}
            onClick={() => onRemove(index)}
            size="xs"
            title={
              copy.components.projectResourceDialog.resourceTypePanelV2
                .projectResourceCard.removeFile
            }
            variant="secondary-transparent-gray"
          />
        </div>
      </div>
      {description ? (
        <Body className={styles.description} size="md" title={description}>
          {description}
        </Body>
      ) : null}
    </div>
  );
};
